import { NgForm } from '@angular/forms';
import { IErrorInfo } from './error-info';
import { BsModalRef } from 'ngx-bootstrap';
import { ModalFormStatus } from './modal-form-status';

export class ModalHandle {
    constructor(modal: BsModalRef, status: ModalFormStatus = ModalFormStatus.Iddle) {
        this.modal = modal;
        this.status = status;
    }

    modal: BsModalRef;
    status: ModalFormStatus;
    form: NgForm;
    error?: Partial<IErrorInfo>;
}
